(function (angular) {
    "use strict";

    angular.module('myApp').filter('messageType', [function () { return function (input) { return getMessageType(input); }; }]);
    angular.module('myApp').filter('messageIcon', [function () { return function (input) { return getMessageIcon(input); }; }]);
    function getMessageType(messageType) { switch (messageType) { case 0: return "danger"; case 1: return "success"; case 3: return "warning"; default: return 'info'; } }
    function getMessageIcon(messageType) { switch (messageType) { case 0: return "times"; case 1: return "check"; case 3: return "warning"; default: return 'info'; } }

    angular.module('myApp').component("alert", {
        templateUrl: '/core/components/alert/alert.tpl.html',
        bindings: {
            service: '='
        }
    });

}(window.angular));